"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialColorWithSizesEditViewModel = instanceOfMaterialColorWithSizesEditViewModel;
exports.MaterialColorWithSizesEditViewModelFromJSON = MaterialColorWithSizesEditViewModelFromJSON;
exports.MaterialColorWithSizesEditViewModelFromJSONTyped = MaterialColorWithSizesEditViewModelFromJSONTyped;
exports.MaterialColorWithSizesEditViewModelToJSON = MaterialColorWithSizesEditViewModelToJSON;
exports.MaterialColorWithSizesEditViewModelToJSONTyped = MaterialColorWithSizesEditViewModelToJSONTyped;
const MaterialColorEditViewModel_1 = require("./MaterialColorEditViewModel");
const MaterialColorSpecDualListItem_1 = require("./MaterialColorSpecDualListItem");
/**
 * Check if a given object implements the MaterialColorWithSizesEditViewModel interface.
 */
function instanceOfMaterialColorWithSizesEditViewModel(value) {
    return true;
}
function MaterialColorWithSizesEditViewModelFromJSON(json) {
    return MaterialColorWithSizesEditViewModelFromJSONTyped(json, false);
}
function MaterialColorWithSizesEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'materialColorEditViewModel': json['materialColorEditViewModel'] == null ? undefined : (0, MaterialColorEditViewModel_1.MaterialColorEditViewModelFromJSON)(json['materialColorEditViewModel']),
        'selectedSizes': json['selectedSizes'] == null ? undefined : (json['selectedSizes'].map(MaterialColorSpecDualListItem_1.MaterialColorSpecDualListItemFromJSON)),
    };
}
function MaterialColorWithSizesEditViewModelToJSON(json) {
    return MaterialColorWithSizesEditViewModelToJSONTyped(json, false);
}
function MaterialColorWithSizesEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'materialColorEditViewModel': (0, MaterialColorEditViewModel_1.MaterialColorEditViewModelToJSON)(value['materialColorEditViewModel']),
        'selectedSizes': value['selectedSizes'] == null ? undefined : (value['selectedSizes'].map(MaterialColorSpecDualListItem_1.MaterialColorSpecDualListItemToJSON)),
    };
}
